<template>
	<transition name="fadeIn">
		<div class="page page-rating-inner">
			<div class="page-container">
				<div class="page-bg"></div>
				<router-link to="/rating" class="nav-link">назад</router-link>

				<div class="week-name-wrapper">
					<div class="week-name">
						<h3 class="text" v-html="week.name"></h3>
						<div class="line"></div>
					</div>
				</div>
				<div class="best-of-week" v-if="weekWinner">
					<div class="best-of-week__inner">
						<div class="best-of-week__cup-image" v-if="!Helpers.isTouch()">
							<svg-cup></svg-cup>
						</div>
						<div class="best-of-week__winner">
							<div class="players-item" v-if="'user' in weekWinner">
								<div class="best-of-week__cup-image" v-if="Helpers.isTouch()">
									<svg-cup></svg-cup>
								</div>
								<div class="best-of-week__winner-header">Победитель недели</div>
								<div class="player-left">
									<div class="player-avatar"
										 :style="'image_link' in weekWinner.user ? `background-image: url(${weekWinner.user.image_link})` : ''"></div>
								</div>
								<div class="player-right">
									<p class="player-name">{{ weekWinner.user.first_name }} {{ weekWinner.user.last_name}}</p>
									<div class="player-data">
										<div class="player-time" v-if="weekWinner.result"><span class="text">{{ toHHMMSS(weekWinner.result.time)}}</span><span class="icon"><clock></clock></span>
										</div>
										<div class="player-points" v-if="weekWinner.result"><span class="text">{{ weekWinner.result.score}}</span><span class="icon"><star></star></span>
										</div>
									</div>
								</div>
							</div>

							<div class="best-of-week__cross">
								<svg-cross></svg-cross>
							</div>

							<div class="players-item">
								<div class="best-of-week__winner-header">Футболист недели</div>
								<div class="player-left">
									<div class="player-avatar"
										 :style="`background-image: url(${weekWinner.player_photo})`"></div>
								</div>
								<div class="player-right">
									<p class="player-name">{{ weekWinner.player_name }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="page-content">
					<div class="players-scroll-wrapper" :class="{fixedHeight: list.length >= 15}" v-bar>
						<div class="players-scroll">
							<ul class="players-list">
								<li class="players-item" v-for="(item, key) in list">
									<div class="player-left">
										<div class="player-position">{{ item.position }}</div>
										<!--<div v-if="'image_link' in item" class="player-avatar"-->
											 <!--:style="'image_link' in item ? `background-image: url(${item.image_link})` : ''"></div>-->
										<!--<div v-else class="player-avatar"></div>-->
										<div class="player-avatar" v-if="item.image_link" :style="`background-image: url(${item.image_link})`"></div>
										<div class="player-avatar" v-else></div>
									</div>
									<div class="player-right">
										<p class="player-name">{{ item.first_name }} {{ item.last_name }}</p>
										<div class="player-data">
											<div class="player-time"><span class="text">{{ toHHMMSS(item.time) }}</span><span
													class="icon"><clock></clock></span>
											</div>
											<div class="player-points"><span class="text">{{ item.score }}</span><span
													class="icon"><star></star></span>
											</div>
											<div class="player-videolink" v-if="item.link">
												<a target="_blank" :href="item.link">+ видеоповтор</a>
											</div>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<router-link :to="'/rating/' + nextWeekIdx" class="nav-link link-next-week" :class="{ active: nextWeekActive }">
					<span v-if="weeks[nextWeekIdx-1] !== undefined" v-html="weeks[nextWeekIdx-1].name"></span>
				</router-link>
			</div>
		</div>
	</transition>
</template>

<script>
	import {TweenMax} from 'gsap'
	import star from '@/assets/svg/star.svg';
	import clock from '@/assets/svg/clock.svg';
	import cross from '@/assets/svg/cross.svg';
	import cup from '@/assets/svg/cup.svg';
	import Helpers from '@/tools/Helpers';

	const best = [];

	const weeks = [
		{
			name: 'первая <br>неделя',
			id: 1,
		},
		{
			name: 'вторая <br>неделя',
			id: 2,
		},
		{
			name: 'третья <br>неделя',
			id: 3,
		},
		{
			name: 'четвертая <br>неделя',
			id: 4,
		},
		{
			name: 'пятая <br>неделя',
			id: 5,
		}
	];

	export default {
		name: 'Rating',
		components: {
			star,
			clock,
			'svg-cross': cross,
			'svg-cup': cup
		},
		data() {
			return {
				i: 0,
				weeks,
				Helpers
			}
		},
		computed: {
			list () {
				return this.$store.getters['getRatingList'];
			},
			week() {
				return this.weeks.find((item) => {
					return item.id === parseInt(this.$route.params.id);
				});
			},
			currentWeek() {
				return this.$store.getters['getCurrentWeek'] || 0;
			},
			weekWinner() {
//				return this.$route.params.id <= this.currentWeek ? this.$store.getters['getWinner'] : null;
				return this.$store.getters['getWinnerByWeek'](this.$route.params.id)
			},
			nextWeekIdx() {
				return parseInt(this.$route.params.id) + 1;
			},
			nextWeekActive() {
				return parseInt(this.$route.params.id) < this.currentWeek;
			},
		},

		beforeRouteUpdate(to, from, next) {
			this.$store.dispatch('getRating', to.params.id).then(() => {
					next();
				},
				() => {
					next('/rating');
				});
		},

		methods: {
			getWeekData(id) {

			},

			toHHMMSS(secs) {
				let sec_num = parseInt(secs, 10);
				let hours = Math.floor(sec_num / 3600) % 24;
				let minutes = Math.floor(sec_num / 60) % 60;
				let seconds = sec_num % 60;
				return ([hours, minutes, seconds]
					.map(v => v < 10 ? "0" + v : v)
					.filter((v, i) => v !== "00" || i > 0)
					.join(":"));
			}
		},
		mounted() {
			this.Helpers.ga().send('load', 'Страница рейтинга недели');
			this.$store.commit('UPD_UI_SHOW', true);
		}
	}

</script>



// WEBPACK FOOTER //
// RatingInner.vue?273d1c9e